import { render, staticRenderFns } from "./OrderSizePopup.vue?vue&type=template&id=5297dbc0&scoped=true"
import script from "./OrderSizePopup.vue?vue&type=script&lang=js"
export * from "./OrderSizePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297dbc0",
  null
  
)

export default component.exports